module.exports = __webpack_public_path__ + "index_pc/media/welcome.70087f1e.aac";